export const environment = {
  production: false,
  endpoint: 'https://tull-api.hypergraphsoftware.com'
};
